import { onMounted, onUpdated, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

import router from '@/router'
import { useContentStore } from '@/stores/content.ts'
import { useSEOStore } from '@/stores/seo.ts'

export const usePageContent = (pageKey: string) => {
  const contentStore = useContentStore()
  const i18n = useI18n()

  const page = ref<PageContent | null>(null)

  const fetchPage = async () => {
    const { data, seo } = await contentStore.getPage(pageKey)

    page.value = data

    useSEOStore().update(seo)
  }

  onMounted(fetchPage)
  onUpdated(async () => {
    if (page.value !== null) {
      // Scroll to hash after Page content is rendered
      await router.push(router.currentRoute.value.fullPath)
    }
  })
  watch(i18n.locale, fetchPage)

  return { page }
}
